import { orchestrator } from 'satcheljs';
import {
    initializeCalendarEventsLoader,
    calendarEventsLoaderInitialized,
} from '../actions/publicActions';
import {
    initializeScenario,
    updateIsInitializingCalendarEventsLoader,
} from '../actions/internalActions';
import {
    getLoadState,
    isInitializingCalendarEventsLoader,
} from '../selectors/calendarEventsLoaderStoreSelectors';
import { updateCalendarIdsAndDateRange } from './updateCalendarIdsAndDateRange';

export const initializeCalendarEventsLoaderOrchestrator = orchestrator(
    initializeCalendarEventsLoader,
    async actionMessage => {
        const { scenarioId, calendarIds, dateRange } = actionMessage;
        if (getLoadState(scenarioId) === 'DoesNotExist') {
            /**
             * if the scenario does not exist in our store trigger a initializeScenario action
             * to initialize it in our store and trigger the initializeCalendarsCache action to begin the
             * initialization of the events data in the store.
             **/
            initializeScenario(scenarioId);
        } else {
            if (isInitializingCalendarEventsLoader(scenarioId)) {
                // if the scenario is already initializing, do nothing
                return;
            }
        }

        await updateCalendarIdsAndDateRange(scenarioId, {
            calendarIds,
            dateRange,
        });

        // trigger a calendarEventsLoaderInitialized action to notify consumers that the scenario is initialized
        calendarEventsLoaderInitialized(scenarioId);

        updateIsInitializingCalendarEventsLoader(false, scenarioId);
    }
);
